import React from "react";
import { Input } from "antd";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const Search = styled(Input.Search)`
  .ant-input {
    padding-left: 16px;
    padding-bottom: 12px;
    padding-top: 12px;
    padding-right: 30px;
    background: transparent;
    z-index: 1;

    & + span i {
      font-size: 20px;
    }
  }

  .ant-input:focus {
    background: white;
  }
`;

const SearchFilter = ({ searchText, setSearchText, isDisabled, loading }) => {
  const { t } = useTranslation();

  const onSearch = value => {
    value = (value || "").trim().toLowerCase();
    if (value !== searchText) setSearchText(value);
  };

  return (
    <Search
      disabled={isDisabled}
      loading={loading}
      style={{ height: 44, margin: "auto 0" }}
      data-test="filters-search"
      className="search"
      defaultValue={searchText}
      placeholder={t("global:search")}
      allowClear={true}
      onSearch={onSearch}
    />
  );
};

export default SearchFilter;
